module.exports = __webpack_public_path__ + "static/media/stalz.598dfb4b.svg";